import type { ParsedUrlQuery } from 'node:querystring';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import type { DeviceType } from 'shared/types';
import * as resultActions from '@/ducks/results/resultsActions';

export const useInitialFilterSync = (query: ParsedUrlQuery, deviceType: DeviceType) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const hasQuery = query && Object.keys(query).length > 0;
        if (hasQuery) {
            dispatch(resultActions.updateFilters({ ...query, nrFUSAds: deviceType.isProbablyMobile ? 1 : 2 }));
        }
    }, [dispatch, query, deviceType]);
};
